import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const socialTab = document.getElementById("social-tab");
    const securityTab = document.getElementById("security-tab");
    const developerTab = document.getElementById("developer-tab");
    const widgetsTab = document.getElementById("widgets-tab");
    const analysisTab = document.getElementById("analysis-tab");

    const tabs = [socialTab, securityTab, developerTab, widgetsTab, analysisTab];

    tabs.forEach(tab => {
      if (tab) {
        tab.addEventListener("click", async event => {
          const response = await fetch(tab.dataset.url);
          const html = await response.text();
          const element = document.querySelector(`#${tab.id}-content`);
          element.innerHTML = html;
        });
      }
    });
  }
}
